export const STATE = {
	ACTIVE: 'active',
	INACTIVE: 'inactive,disabled',
} as const;
export type TState = (typeof STATE)[keyof typeof STATE];
